import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyVideoSteps from "./component";

const mapStateToProps = ({
    postInspectionDiy: {
        helperVideos
    }
}) => ({
    helperVideos
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyVideoSteps);
